export const GET_MAKEMODELS_STATED = 'GET_MAKEMODELS_STATED';
export const GET_MAKEMODELS = 'GET_MAKEMODELS';
export const GET_MAKEMODELS_ENDED = 'GET_MAKEMODELS_ENDED';
export const ADD_MAKEMODEL_STATED = 'ADD_MAKEMODEL_STARTED';
export const ADD_MAKEMODEL = 'ADD_MAKEMODEL';
export const ADD_MAKEMODEL_ENDED = 'ADD_MAKEMODEL_ENDED';
export const EDIT_MAKEMODEL_STATED = 'EDIT_MAKEMODEL_STATED';
export const EDIT_MAKEMODEL = 'EDIT_MAKEMODEL';
export const EDIT_MAKEMODEL_ENDED = 'EDIT_MAKEMODEL_ENDED';
export const GET_MAKEMODEL = 'GET_MAKEMODEL';
export const GET_MAKEMODEL_STATED = 'GET_MAKEMODEL_STATED';
export const GET_MAKEMODEL_ENDED = 'GET_MAKEMODEL_ENDED';
export const RESET_MAKEMODEL = 'RESET_MAKEMODEL';
export const ERROR_MAKEMODEL = 'ERROR_MAKEMODEL';
export const GET_ALL_MAKEMODELS_STATED = 'GET_ALL_MAKEMODELS_STATED';
export const GET_ALL_MAKEMODELS = 'GET_ALL_MAKEMODELS';
export const GET_ALL_MAKEMODELS_ENDED = 'GET_ALL_MAKEMODELS_ENDED';
